if (!customElements.get('game-skyline')) {
  customElements.define(
    'game-skyline',
    class GameSkyline extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-animate')) return;
        if (window.Shopify && Shopify.designMode) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        this.classList.add('is-pending');
        // Force a reflow so the hidden state applies before transitions are enabled.
        this.getBoundingClientRect();
        this.classList.add('is-armed');

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.remove('is-pending');
            this.observer.disconnect();
          },
          { threshold: 0.5 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
